<template>
  <div class="profit-shell">
    <div class="profit-header">
      <div>
        <p class="eyebrow mb-25">กำไรสุทธิวันนี้</p>
        <h4 class="mb-0">ภาพรวมผลประกอบการ</h4>
      </div>
      <span class="profit-status" :class="todayProfit >= 0 ? 'is-positive' : 'is-negative'">
        <i :class="todayProfit >= 0 ? 'fas fa-arrow-trend-up' : 'fas fa-arrow-trend-down'" />
        {{ formatPercent(todayProfitPercent) }}
      </span>
    </div>

    <b-overlay :show="todayLoading">
      <div class="profit-hero" :class="todayProfit >= 0 ? 'hero-positive' : 'hero-negative'">
        <div class="hero-glow" />
        <div class="hero-line" />
        <div class="hero-content">
          <span class="hero-label">
            <i class="fas fa-calendar-day" />
            ยอดเงินวันนี้ (THB)
          </span>
          <div class="hero-value">
            {{ formatMoney(todayProfit) }}
            <span>THB</span>
          </div>
          <small class="hero-caption">คำนวณจากยอดฝาก ยอดถอน โบนัส และเกมของวันนี้</small>
        </div>
        <div class="hero-icon">
          <i class="fas fa-chart-line" />
        </div>
      </div>
    </b-overlay>

    <b-overlay :show="profitLoading">
      <div class="profit-total">
        <div>
          <span class="total-label">กำไรสุทธิรวมทั้งหมด</span>
          <h2 class="total-value mb-0">
            {{ formatMoney(profit) }}
            <span>THB</span>
          </h2>
        </div>
        <span class="total-pill">All time</span>
      </div>

      <div class="profit-breakdown">
        <div
          v-for="item in breakdownItems"
          :key="item.key"
          class="breakdown-card"
          :class="`breakdown-${item.color}`"
        >
          <span class="breakdown-icon">
            <i :class="item.icon" />
          </span>
          <div>
            <small>{{ item.label }}</small>
            <h5 class="mb-0">{{ formatMoney(item.value) }}</h5>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay,
} from 'bootstrap-vue'

export default {
  components: {
    BOverlay,
  },
  data() {
    return {
      isLoading: false,
      todayProfit: 0,
      todayProfitKR: 0,
      profit: 0,
      profitKR: 0,
      game: 0,
      gameKR: 0,
      bonus: 0,
      bonusKR: 0,
      todayProfitPercent: 0,
      todayProfitPercentKR: 0,
      depSum: 0,
      depSumKR: 0,
      witSum: 0,
      witSumKR: 0,
      data: null,
      todayLoading: false,
      todayLoadingKR: false,
      profitLoading: false,
      profitLoadingKR: false,
    }
  },
  mounted() {
    this.getTodayPofit()
    this.getPofit()
  },
  computed: {
    breakdownItems() {
      return [
        {
          key: 'deposit',
          label: 'ยอดฝาก',
          value: this.depSum,
          icon: 'fas fa-chevron-down',
          color: 'success',
        },
        {
          key: 'withdraw',
          label: 'ยอดถอน',
          value: this.witSum,
          icon: 'fas fa-chevron-up',
          color: 'danger',
        },
        {
          key: 'bonus',
          label: 'โบนัส',
          value: this.bonus,
          icon: 'fas fa-gift',
          color: 'info',
        },
        {
          key: 'game',
          label: 'เกม',
          value: this.game,
          icon: 'fas fa-dice',
          color: 'warning',
        },
      ]
    },
  },
  methods: {
    formatMoney(value) {
      return Number(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
    formatPercent(value) {
      const sign = Number(value || 0) > 0 ? '+' : ''
      const number = Number(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
      return `${sign}${number}%`
    },
    async getTodayPofit() {
      this.todayLoading = true
      try {
        const { data } = await this.$http.get('/dashboard?type=TODAY_PROFIT')
        this.todayProfit = data.todayProfit
        this.todayProfitPercent = data.todayProfitPercent ? data.todayProfitPercent : 0
      } catch (error) {
        console.log(error)
      } finally {
        this.todayLoading = false
      }
    },
    async getTodayPofitKR() {
      this.todayLoadingKR = true
      try {
        const { data } = await this.$http.get('/dashboard?type=TODAY_PROFIT_KR')
        this.todayProfitKR = data.todayProfitKR
        this.todayProfitPercentKR = data.todayProfitPercentKR ? data.todayProfitPercentKR : 0
      } catch (error) {
        console.log(error)
      } finally {
        this.todayLoadingKR = false
      }
    },
    async getPofit() {
      this.profitLoading = true
      try {
        const { data } = await this.$http.get('/dashboard?type=PROFIT')
        this.profit = data.profit
        this.game = data.game
        this.bonus = data.bonus
        this.depSum = data.depSum
        this.witSum = data.witSum
      } catch (error) {
        console.log(error)
      } finally {
        this.profitLoading = false
      }
    },
    async getPofitKR() {
      this.profitLoadingKR = true
      try {
        const { data } = await this.$http.get('/dashboard?type=PROFIT_KR')
        this.profitKR = data.profitKR
        this.gameKR = data.gameKR
        this.bonusKR = data.bonusKR
        this.depSumKR = data.depSumKR
        this.witSumKR = data.witSumKR
      } catch (error) {
        console.log(error)
      } finally {
        this.profitLoadingKR = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.profit-shell {
  position: relative;
  height: 100%;
  padding: 18px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(34, 41, 47, 0.06);
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.04);
  overflow: hidden;
}

.profit-shell::before {
  content: '';
  position: absolute;
  top: -70px;
  right: -90px;
  width: 220px;
  height: 220px;
  border-radius: 999px;
  background: radial-gradient(circle, rgba(40, 199, 111, 0.14), rgba(40, 199, 111, 0));
  pointer-events: none;
}

.profit-header {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 14px;
}

.eyebrow {
  color: #8b93a7;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.profit-header h4 {
  color: #283046;
  font-size: 1.05rem;
  font-weight: 800;
}

.profit-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 800;
  white-space: nowrap;
}

.profit-status.is-positive {
  background: rgba(40, 199, 111, 0.12);
  color: #1d995a;
}

.profit-status.is-negative {
  background: rgba(234, 84, 85, 0.12);
  color: #d23a3b;
}

.profit-hero {
  position: relative;
  min-height: 112px;
  padding: 18px 20px;
  border-radius: 16px;
  overflow: hidden;
  color: #193b32;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid rgba(40, 199, 111, 0.16);
  box-shadow: 0 14px 30px rgba(40, 199, 111, 0.1);
}

.hero-positive {
  background: linear-gradient(135deg, #f7fffb 0%, #effcf5 48%, #e8f9f0 100%);
}

.hero-negative {
  color: #4a1d1d;
  background: linear-gradient(135deg, #fff8f8 0%, #fff0f0 48%, #ffecec 100%);
  border-color: rgba(234, 84, 85, 0.14);
  box-shadow: 0 14px 30px rgba(234, 84, 85, 0.1);
}

.hero-glow {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, rgba(40, 199, 111, 0), rgba(40, 199, 111, 0.35), rgba(40, 199, 111, 0));
}

.hero-line {
  position: absolute;
  left: 0;
  top: 18px;
  bottom: 18px;
  width: 4px;
  border-radius: 0 999px 999px 0;
  background: linear-gradient(180deg, #16a085, #28c76f);
}

.hero-negative .hero-line {
  background: linear-gradient(180deg, #c0392b, #ea5455);
}

.hero-negative .hero-glow {
  background: linear-gradient(90deg, rgba(234, 84, 85, 0), rgba(234, 84, 85, 0.3), rgba(234, 84, 85, 0));
}

.hero-content,
.hero-icon {
  position: relative;
  z-index: 1;
}

.hero-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 0.78rem;
  color: #5f776d;
  margin-bottom: 6px;
  font-weight: 800;
  letter-spacing: 0.15px;
}

.hero-negative .hero-label {
  color: #936464;
}

.hero-value {
  color: #13945f;
  font-size: 1.75rem;
  font-weight: 900;
  letter-spacing: -0.7px;
  line-height: 1.1;
}

.hero-negative .hero-value {
  color: #d23a3b;
}

.hero-value span,
.total-value span {
  font-size: 0.78rem;
  font-weight: 800;
  opacity: 0.75;
}

.hero-caption {
  display: block;
  margin-top: 6px;
  color: #7a8d84;
  font-size: 0.72rem;
  font-weight: 600;
}

.hero-negative .hero-caption {
  color: #9b7474;
}

.hero-icon {
  width: 48px;
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #fff;
  background: linear-gradient(135deg, #16a085, #28c76f);
  font-size: 1.15rem;
  box-shadow: 0 10px 22px rgba(40, 199, 111, 0.24);
}

.hero-negative .hero-icon {
  background: linear-gradient(135deg, #c0392b, #ea5455);
  box-shadow: 0 10px 22px rgba(234, 84, 85, 0.22);
}

.profit-total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 14px;
  padding: 14px 16px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(115, 103, 240, 0.08), rgba(115, 103, 240, 0.02));
  border: 1px solid rgba(115, 103, 240, 0.08);
}

.total-label {
  display: block;
  color: #8b93a7;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 4px;
}

.total-value {
  color: #283046;
  font-weight: 900;
  font-size: 1.35rem;
}

.total-pill {
  padding: 5px 10px;
  border-radius: 999px;
  background: #fff;
  color: #7367f0;
  font-size: 0.72rem;
  font-weight: 800;
  box-shadow: 0 4px 12px rgba(115, 103, 240, 0.08);
}

.profit-breakdown {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.breakdown-card {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 12px;
  border-radius: 14px;
  background: #fbfcff;
  border: 1px solid rgba(34, 41, 47, 0.06);
}

.breakdown-icon {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  font-size: 0.9rem;
}

.breakdown-card small {
  display: block;
  color: #8b93a7;
  font-size: 0.72rem;
  font-weight: 700;
}

.breakdown-card h5 {
  color: #283046;
  font-size: 0.95rem;
  font-weight: 900;
  word-break: break-word;
}

.breakdown-success .breakdown-icon { background: linear-gradient(135deg, #28c76f, #48da89); }
.breakdown-danger .breakdown-icon { background: linear-gradient(135deg, #ea5455, #ff7b7c); }
.breakdown-info .breakdown-icon { background: linear-gradient(135deg, #00cfe8, #1ad7ee); }
.breakdown-warning .breakdown-icon { background: linear-gradient(135deg, #ff9f43, #ffb976); }

@media (max-width: 575.98px) {
  .profit-breakdown {
    grid-template-columns: 1fr;
  }

  .hero-value {
    font-size: 1.55rem;
  }
}
</style>
